import React, { Dispatch, SetStateAction } from 'react'

export const ImportTransactionsContext = React.createContext<{
  newNumTransactions: number | null
  setNewNumTransactions: Dispatch<SetStateAction<number | null>>
}>({ newNumTransactions: null, setNewNumTransactions: () => null })
